import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Wrapper } from './Uploader.styles'
import Dropzone from 'react-dropzone'
import PropTypes from 'prop-types'
import { useFileServer } from 'lib/the-file-server'

class Uploader extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      progress: 0
    }
    this.onDrop = this.onDrop.bind(this)
  }

  static propTypes = {
    uploadedImage: PropTypes.func
  }

  onDrop (file) {
    this.props.upload(file)
      .then(data => {
        this.props.uploadedImage(data.publicUrl)
      })
      .catch(err => {
        console.log(err)
      })
  }

  render () {
    return (
      <Wrapper>
        <div
          className='drop-zone'
          style={{
            position: 'relative',
            height: '200px',
            width: '200px',
            cursor: 'pointer'
          }}
        >
          <div
            className='progress'
            style={{
              width: `${this.state.progress}%`,
              background: 'rgba(107, 188, 102, 0.7)'
            }}
          >
            {' '}
          </div>
          <Dropzone accept={{ 'image/*': ['image/jpeg', 'image/png']}} onDrop={this.onDrop}>
            {
              ({getRootProps, getInputProps}) =>  <div {...getRootProps()} style={{ height: '100%', width: '100%' }}>
                <>
                  <div className='label'>
                    <FormattedMessage
                      id='uploaderDragOrClick'
                      defaultMessage='Drag your image here or click to upload'
                    />
                  </div>
                  <input {...getInputProps()} />
                </>
              </div>
            }
          </Dropzone>
        </div>
      </Wrapper>
    )
  }
}

export default (props) => {
  const { upload } = useFileServer()
  return <Uploader {...props} upload={upload} />
}